import moment from 'moment'

function getShifouqushenpiMoren(formData, pageType, that) {
  if (pageType === 'launch' || pageType === 'draft' || pageType === 'relaunch') {
    // if (pageType === 'relaunch') {
    //   // alert('触发了')
    //     console.log('tset')
    //     console.log(formData)
    //   that.$emit('shifouqushenpiChange', formData.process_config_is_district)
    // }
    return formData.process_config_is_district
  } else {
    return formData.process_config_is_district === '0' ? '否' : '是'
  }
}

function getOldReviewMembers(formData) {
    if (!formData.review_members_new) {
        var members = []
        if (formData.review_members) {
            members.push(formData.review_members)
        }
        if (formData.review_members2) {
            members.push(formData.review_members2)
        }
        if (formData.review_members3) {
            members.push(formData.review_members3)
        }
        if (formData.review_members4) {
            members.push(formData.review_members4)
        }
        if (formData.review_members5) {
            members.push(formData.review_members5)
        }
        return members.join(';')
    }
}

export const forms = {
  getBaseForm(formData, extend, pageType, that) {
    var moren = ''
    if (pageType === 'launch' || pageType === 'draft' || pageType === 'relaunch') {
      moren = ''
    } else {
      moren = '--'
    }
    const getType = (name, type) => {
      if (extend.checkDisabled(name)) {
        return 'text'
      } else {
        return type
      }
    }
    const data = [
      {
        type: getType('review_isAgree', 'switch'),
        label: '是否同意',
        col: '12',
        lineFeed: true,
        defaultValue: extend.checkDisabled('review_isAgree')
          ? formData.review_isAgree
            ? '是'
            : '否'
          : formData.review_isAgree || true,
        checkedChildren: '是',
        unCheckedChildren: '否',
        id: 'review_isAgree',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('review_time', 'datePicker'),
        label: '评议时间',
        rules: [
          {
            required: true,
            message: '请选择评议日期'
          }
        ],
        // disabledDate: (current) => { return current && current >= moment().startOf('day') },
        // disabled: extend.checkDisabled,
        format: 'YYYY-MM-DD',
        lineFeed: true,
        defaultValue: extend.checkDisabled('review_time')
          ? formData.review_time
            ? `${formData.review_time}`
            : ''
          : formData.review_time
            ? moment(formData.review_time, 'YYYY-MM-DD')
            : null,
        col: '12',
        id: 'review_time',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('review_members', 'input'),
        label: '评议人员',
        rules: [
          {
            required: true,
            message: '请填写评议成员'
          }
        ],
        // col: extend.checkDisabled('review_time') ? '5' : '8',
        col: '14',
        defaultValue: formData.review_members_new || getOldReviewMembers(formData),
        id: 'review_members_new',
        layout: {
          labelCol: '120px'
        }
      },
      {
          type: 'children',
          name: 'review_members_new_tip',
          col: '10'
      },
      // {
      //   type: getType('review_members2', 'input'),
      //   label: '',
      //   col: extend.checkDisabled('review_time') ? '2' : '4',
      //   defaultValue: formData.review_members2 || '',
      //   id: 'review_members2',
      //   layout: {
      //     labelCol: '10px'
      //   }
      // },
      // {
      //   type: getType('review_members3', 'input'),
      //   label: '',
      //   col: extend.checkDisabled('review_time') ? '2' : '4',
      //   defaultValue: formData.review_members3 || '',
      //   id: 'review_members3',
      //   layout: {
      //     labelCol: '10px'
      //   }
      // },
      // {
      //   type: getType('review_members4', 'input'),
      //   label: '',
      //   col: extend.checkDisabled('review_time') ? '2' : '4',
      //   defaultValue: formData.review_members4 || '',
      //   id: 'review_members4',
      //   layout: {
      //     labelCol: '10px'
      //   }
      // },
      // {
      //   type: getType('review_members5', 'input'),
      //   label: '',
      //   col: extend.checkDisabled('review_time') ? '2' : '4',
      //   defaultValue: formData.review_members5 || '',
      //   id: 'review_members5',
      //   layout: {
      //     labelCol: '10px'
      //   }
      // },
      // {
      //   type: getType('review_content', 'textarea'),
      //   label: '评议内容',
      //   rules: [
      //     {
      //       required: true,
      //       message: '请填写评议内容'
      //     }
      //   ],
      //   col: '12',
      //   lineFeed: true,
      //   defaultValue: formData.review_content || '',
      //   id: 'review_content',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      {
        type: getType('review_acceptanceOpinions', 'textarea'),
        label: '评议意见',
        rules: [
          {
            required: true,
            message: '请填写评议意见'
          }
        ],
        col: '24',
        lineFeed: true,
        autoSize: { minRows: 5, maxRows: 20 },
        defaultValue: formData.review_acceptanceOpinions || '',
        id: 'review_acceptanceOpinions',
        layout: {
          labelCol: '120px'
        }
      },
      // {
      //   type: getType('review_money', 'input'),
      //   label: '拟帮扶资金',
      //   rules: [{
      //     required: true,
      //     message: '请填写拟帮扶资金'
      //   }],
      //   col: '12',
      //   lineFeed: true,
      //   defaultValue: formData.review_money || '',
      //   id: 'review_money',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      {
        type: getType('individual_case_support_funds', 'input'),
        label: '拟帮扶金额',
        rules: [
          {
            pattern: /^(([0-9]+.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*.[0-9]+)|([0-9]*[1-9][0-9]*))$/,
            message: '请输入正确的金额'
          },
          {
            required: true,
            message: '请填写拟帮扶金额'
          }
        ],
        suffix: '元',
        col: '12',
        defaultValue: formData.individual_case_support_funds || moren,
        lineFeed: true,
        id: 'individual_case_support_funds',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('process_config_is_district', 'radio'),
        label: '是否提交区审批',
        col: '24',
        id: 'process_config_is_district',
        onChange: that.onChange,
        defaultValue: getShifouqushenpiMoren(formData, pageType, that),
        rules: [
          {
            required: true,
            message: '请选择是否提交区审批'
          }
        ],
        options: [
          {
            label: '是',
            value: '1'
          },
          {
            label: '否',
            value: '0'
            // disabled: true
          }
        ],
        layout: {
          labelCol: '120px'
        }
      },

      {
        type: getType('review_remarks', 'textarea'),
        label: '备注',
        col: '24',
        lineFeed: true,
        defaultValue: formData.review_remarks || moren,
        id: 'review_remarks',
        layout: {
          labelCol: '120px'
        }
      }
    ]
    return data
  }
}
